// Maps backend uber_batch.status values to a tailwind-styled pill and an i18n key.
// The label itself is rendered via i18n to keep all user-facing strings translatable.

export const UBER_BATCH_STATUSES = ['pending', 'submitted', 'route_planned', 'failed']

// Only submission-rejected batches are retryable — other failure reasons mean
// the deliveries themselves were rejected and a retry would fail identically.
// Mirrors UberBatch::FAILED_REASON_REJECTED_AT_SUBMISSION on the backend.
export const RETRYABLE_FAILURE_REASON = 'uber_rejected_at_submission'

const STATUS_CLASSES = {
    pending: 'bg-gray-100 text-gray-800',
    submitted: 'bg-blue-100 text-blue-800',
    route_planned: 'bg-green-100 text-green-800',
    failed: 'bg-red-100 text-red-800',
}

export const getUberBatchStatusClass = (status) => {
    return STATUS_CLASSES[status] || 'bg-gray-100 text-gray-800'
}

export const getUberBatchStatusLabelKey = (status) => {
    if (UBER_BATCH_STATUSES.includes(status)) {
        return `uber_batches.status.${status}`
    }
    return null
}
